import React from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {Navigate, Route, Routes} from 'react-router-dom'
import {UtilisateursListPage} from "./UtilisateursListPage";
import {UtilisateurAddPage} from "./UtilisateurAddPage";
import {UtilisateurEditPage} from "./UtilisateurEditPage";

const UtilisateursWrapper = () => {
  const intl = useIntl()
  return (
      <>
          <Routes>

              <Route
                  path='/liste'
                  element={
                      <>
                        <PageTitle breadcrumbs={[
                          { title: 'Utilisateurs', path: '#', isSeparator: false, isActive: true },
                        ]}>Liste</PageTitle>
                          <UtilisateursListPage />
                      </>
                  }
              />
              <Route
                  path='/ajouter'
                  element={
                      <>
                        <PageTitle breadcrumbs={[
                          { title: 'Utilisateurs', path: '/utilisateurs', isSeparator: false, isActive: true },
                        ]}>Création</PageTitle>
                          <UtilisateurAddPage />
                      </>
                  }
              />
              <Route
                  path=':utilisateurId/modifier'
                  element={
                      <>
                        <PageTitle breadcrumbs={[
                          { title: 'Utilisateurs', path: '/utilisateurs', isSeparator: false, isActive: true },
                        ]}>Modification</PageTitle>
                          <UtilisateurEditPage />
                      </>
                  }
              />
              <Route index element={<Navigate to='/utilisateurs/liste' />} />
          </Routes>
      </>
  )
}

export {UtilisateursWrapper}
